import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * Levels & plans now live inside Floor plan.
 * Keep this route so old bookmarks/links still work.
 */
export default function BuildingLevels() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/buildings/${id}/floor-plan`, { replace: true });
  }, [id, navigate]);

  return <div className="text-center py-12 text-gray-500">Opening Floor plan…</div>;
}
